export const ARTIFACT_SHARE_LABELS = {
  requirements: 'SRD doc',
  'user-flow': 'user flow',
  design: 'design',
  architecture: 'architecture',
  tasks: 'tasks',
} as const;

export type ShareableArtifactType = keyof typeof ARTIFACT_SHARE_LABELS;

export interface ArtifactShareRequest {
  projectId: string;
  artifactType: ShareableArtifactType;
  itemId?: string | null;
  subview?: string | null;
}

export const OPEN_ARTIFACT_SHARE_EVENT = 'open_artifact_share';

export const isShareableArtifactType = (value: unknown): value is ShareableArtifactType => (
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(ARTIFACT_SHARE_LABELS, value)
);

export const openArtifactShare = (request: ArtifactShareRequest): void => {
  if (!request.projectId || !isShareableArtifactType(request.artifactType)) return;
  window.dispatchEvent(new window.CustomEvent(OPEN_ARTIFACT_SHARE_EVENT, { detail: request }));
};
